import R from 'ramda';

import biCardTemplate from './biCard.tpl.html';

export class BiCard {
  isEditMode() {
    return !R.isNil(this.editMode) && this.editMode;
  }

  removeCard() {
    this.onRemoveCard();
  }
}

export const tctBiCard = {
  template: biCardTemplate,
  controller: BiCard,
  bindings: {
    template: '<',
    data: '<',
    editMode: '<?',
    onRemoveCard: '&',
  },
};
